// extracted by css-extract-rspack-plugin
export default {"edge":"aMAnDhuLX7o4EnU_","edgeLabel":"Drw8h0aS2hcDc8Ob"};